var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "app-wrapper"
  }, [_c("Header"), _vm._v(" "), _c("AppMain"), _vm._v(" "), _c("Footer")], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };